// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import clone from 'lodash/clone'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

// Components
import FocalImage from 'ui/components/FocalImage'
import Icon from 'ui/components/Icon'
import BProductButton from 'store/modules/product/blocks/ProductButton'

// Shared
import NO_PRODUCT_IMAGE from '@assets/images/no-product-image.png'

export class BundleItems extends Component {
  static displayName = 'ProductButtonBundleItems'

  static propTypes = {
    bundleItems: PropTypes.object,
    products: PropTypes.object,
    productGroups: PropTypes.object,
    photos: PropTypes.object,
    configuration: PropTypes.object,
    setBundleConfiguration: PropTypes.func
  }

  componentDidMount = () => {
    this.chooseInitialConfiguration()
  }

  chooseInitialConfiguration = () => {
    const { bundleItems, products, configuration } = this.props
    const newConfiguration = clone(configuration)

    bundleItems.forEach((bundleItem) => {
      if (bundleItem.product_id) {
        // Specified BundleItem => Use preconfigured Product
        newConfiguration[bundleItem.id] = bundleItem.product_id
      } else if (isEmpty(configuration[bundleItem.id])) {
        // Unspecified BundleItem => Pick Product based on sorting_weight
        // sorting_weight determines order in which Products are shown under Product>Variations in the Back Office
        const choices = products.getAll({ product_group_id: bundleItem.product_group_id }).sort('sorting_weight')
        newConfiguration[bundleItem.id] = choices.getFirst().id
      }
    })

    if (!isEqual(newConfiguration, configuration)) {
      this.props.setBundleConfiguration(newConfiguration)
    }
  }

  handleChangeVariation = (bundleItemId, e) => {
    const { configuration } = this.props
    const selectedProductId = e.target.value

    const newConfiguration = clone(configuration)
    newConfiguration[bundleItemId] = selectedProductId

    this.props.setBundleConfiguration(newConfiguration)
  }

  renderSelectVariation = (bundleItemId, products, selectedProduct) => {
    return (
      <div className="bq-variation-wrapper">
        <select
          name="variation"
          className="bq-variation"
          onChange={this.handleChangeVariation.bind(null, bundleItemId)}
          value={selectedProduct || ''}
        >
          {products.map((product) => (
            <option key={`${bundleItemId}-${product.id}`} value={product.id}>
              {product.name}
            </option>
          ))}
        </select>
        <Icon icon="angle-down" />
      </div>
    )
  }

  renderItem = (bundleItem) => {
    const { products, productGroups, photos, configuration } = this.props
    const productGroup = productGroups.getById(bundleItem.product_group_id)
    const product = products.getById(bundleItem.product_id)
    const variation = products.getById(configuration[bundleItem.id])
    const item = variation || product || productGroup
    const photo = photos.getById(item.photo_id)
    const choices = products.getAll({ product_group_id: productGroup.id }).sort('sorting_weight')

    return (
      <BProductButton.BundleItemRow key={bundleItem.id}>
        <BProductButton.BundleItemCell>
          <FocalImage
            url={(photo && photo.large_url) || NO_PRODUCT_IMAGE}
            preview={photo && photo.preview}
            coordinates={photo && photo.coordinates}
            size="40px"
          />
        </BProductButton.BundleItemCell>
        <BProductButton.BundleItemCell disabled>
          {bundleItem.quantity}x
        </BProductButton.BundleItemCell>
        <BProductButton.BundleItemCell>
          {(!productGroup.has_variations || bundleItem.product_id) &&
            item.name}
          {productGroup.has_variations && !bundleItem.product_id &&
            this.renderSelectVariation(bundleItem.id, choices, configuration[bundleItem.id])}
        </BProductButton.BundleItemCell>
      </BProductButton.BundleItemRow>
    )
  }

  render () {
    const { bundleItems } = this.props

    return (
      <BProductButton.BundleItems className="bq-bundle-contents">
        {bundleItems.map((item) => this.renderItem(item))}
      </BProductButton.BundleItems>
    )
  }
}

const mapStateToProps = (state, props) => {
  const bundleItems = state.orm.bundle_items.getAll({ bundle_id: props.item.id })
  const productGroupIds = bundleItems.pluck('product_group_id')
  const productGroups = state.orm.product_groups.getById(productGroupIds)
  const products = state.orm.products.getAll({ product_group_id: productGroupIds })

  return {
    bundleItems,
    products,
    productGroups,
    photos: state.orm.photos.getAll()
  }
}

export default reduxConnect(mapStateToProps, null)(BundleItems)
